<header class="app-topbar relative h-14 min-h-14 bg-white dark:bg-topbar border-b border-[#E8EDF2] dark:border-topbar-line shadow-[0_1px_3px_rgba(15,23,42,0.04)] dark:shadow-[0_1px_3px_rgba(0,0,0,0.24)] flex items-center justify-between gap-2 min-w-0 px-2 sm:px-4 lg:px-6 py-0 shrink-0">

  <!-- Left side: Toggle -->
  <div class="topbar-left flex flex-1 items-center min-w-0 gap-2">
    <!-- Sidebar Toggle Button -->
    <button
      type="button"
      (click)="sidebar.toggle()"
      class="sm:hidden flex items-center justify-center w-8 h-8 rounded-md text-[#8A96A8] dark:text-muted hover:text-[#10192D] dark:hover:text-ink hover:bg-[#F0F4F8] dark:hover:bg-chart transition-colors cursor-pointer bg-transparent border-0 p-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#129E91] dark:focus-visible:outline-primary"
      [attr.aria-label]="sidebar.open() ? 'Collapse sidebar' : 'Expand sidebar'"
      [title]="sidebar.open() ? 'Collapse sidebar' : 'Expand sidebar'"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="transition-transform duration-200" [class.rotate-180]="!sidebar.open()">
        <rect width="18" height="18" x="3" y="3" rx="2" />
        <path d="M9 3v18" />
      </svg>
    </button>

    @if (isTimesheetsRoute) {
      <div class="flex min-w-0 items-center gap-2 overflow-x-auto" aria-label="Timesheets date filters">
        <span class="shrink-0 text-[10px] font-semibold uppercase tracking-wide text-[#50647A] dark:text-muted">Period end</span>
        <p-datepicker [ngModel]="timesheetsFromDateValue" (ngModelChange)="onTimesheetsDateChange('from', $event)"
          [maxDate]="timesheetsToDateValue ?? undefined" dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY"
          [showIcon]="true" [readonlyInput]="true" iconDisplay="input" icon="pi pi-calendar" appendTo="body"
          class="w-[164px] shrink-0" [style]="{ width: '164px' }"
          inputStyleClass="h-8 w-[164px] cursor-pointer rounded-md border border-[#D7E0EA] bg-white py-0 pl-2 pr-9 text-[12px] text-[#10192D] outline-none focus:border-[#129E91] dark:border-topbar-line dark:bg-chart dark:text-ink"
          ariaLabel="Timesheets period end date from" />
        <span class="shrink-0 text-[11px] text-[#66758A] dark:text-muted">to</span>
        <p-datepicker [ngModel]="timesheetsToDateValue" (ngModelChange)="onTimesheetsDateChange('to', $event)"
          [minDate]="timesheetsFromDateValue ?? undefined" dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY"
          [showIcon]="true" [readonlyInput]="true" iconDisplay="input" icon="pi pi-calendar" appendTo="body"
          class="w-[164px] shrink-0" [style]="{ width: '164px' }"
          inputStyleClass="h-8 w-[164px] cursor-pointer rounded-md border border-[#D7E0EA] bg-white py-0 pl-2 pr-9 text-[12px] text-[#10192D] outline-none focus:border-[#129E91] dark:border-topbar-line dark:bg-chart dark:text-ink"
          ariaLabel="Timesheets period end date to" />
        <button
          type="button"
          (click)="searchTimesheets()"
          [disabled]="!timesheetsFromDate || !timesheetsToDate || timesheetsFromDate > timesheetsToDate"
          class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-[#129E91] bg-[#129E91] text-white transition-colors hover:bg-[#0E897E] disabled:cursor-not-allowed disabled:opacity-40 dark:border-primary dark:bg-primary"
          aria-label="Search timesheets for selected date range"
          title="Search"
        >
          <i class="pi pi-search text-[12px]" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          (click)="resetTimesheetsDateRange()"
          class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-[#D7E0EA] bg-white text-[#8A96A8] transition-colors hover:border-[#129E91] hover:text-[#129E91] dark:border-topbar-line dark:bg-chart dark:text-muted dark:hover:border-primary dark:hover:text-primary"
          aria-label="Reset Timesheets date range to current month"
          title="Reset to current month"
        >
          <i class="pi pi-times text-[11px]" aria-hidden="true"></i>
        </button>
      </div>
    }

    @if (isPlacementsRoute) {
    <nav class="flex h-14 items-end gap-6" role="tablist" aria-label="Placement views">
      <a
        routerLink="/placements"
        [queryParams]="{ view: 'live' }"
        role="tab"
        [attr.aria-selected]="placementView === 'live-placements'"
        [ngClass]="placementView === 'live-placements' ? 'border-primary text-primary' : 'border-transparent text-[#50647A] dark:text-muted hover:text-primary'"
        class="-mb-px border-b-2 px-0 pb-3 text-[13px] font-medium transition-colors"
      >Live Placements</a>
      <a
        routerLink="/placements"
        role="tab"
        [attr.aria-selected]="placementView === 'placements'"
        [ngClass]="placementView === 'placements' ? 'border-primary text-primary' : 'border-transparent text-[#50647A] dark:text-muted hover:text-primary'"
        class="-mb-px border-b-2 px-0 pb-3 text-[13px] font-medium transition-colors"
      >Placements</a>
    </nav>
    }

    @if (isBalanceSheetItemsRoute) {
      <div class="flex min-w-0 items-center gap-2" aria-label="Balance Sheet Items month filter">
        <span class="shrink-0 text-[10px] font-semibold uppercase tracking-wide text-[#50647A] dark:text-muted">Month</span>
        <p-datepicker
          [ngModel]="balanceSheetItemsState.selectedMonth()"
          (ngModelChange)="onBalanceSheetMonthSelect($event)"
          (onSelect)="onBalanceSheetMonthSelect($event)"
          view="month"
          dateFormat="MM yy"
          [maxDate]="balanceSheetMaxMonth"
          placeholder="Select month"
          [showIcon]="true"
          [readonlyInput]="true"
          iconDisplay="input"
          icon="pi pi-calendar"
          appendTo="body"
          class="w-[190px] shrink-0"
          [style]="{ width: '190px' }"
          inputStyleClass="h-8 w-[190px] cursor-pointer rounded-md border border-[#D7E0EA] bg-white py-0 pl-3 pr-9 text-[13px] font-semibold text-[#10192D] outline-none focus:border-[#129E91] dark:border-topbar-line dark:bg-chart dark:text-ink"
          ariaLabel="Balance Sheet Items month"
        />
        <button
          type="button"
          (click)="clearBalanceSheetMonth()"
          class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md border border-[#D7E0EA] bg-white text-[#8A96A8] transition-colors hover:border-[#129E91] hover:text-[#129E91] disabled:cursor-not-allowed disabled:opacity-40 dark:border-topbar-line dark:bg-chart dark:text-muted dark:hover:border-primary dark:hover:text-primary"
          aria-label="Reset Balance Sheet Items to the current month"
          title="Reset to current month"
        >
          <i class="pi pi-times text-[11px]" aria-hidden="true"></i>
        </button>
      </div>
    } @else if (showDashboardControls) {
    <div class="relative flex min-w-0 flex-1 items-center gap-2">
    <div class="dashboard-filter-bar flex h-10 w-full min-w-0 items-center gap-2 overflow-x-auto rounded-xl border border-[#E4EAF1] dark:border-topbar-line bg-white dark:bg-[#0F1826] px-2.5 py-0 shadow-[0_8px_24px_rgba(15,23,42,0.06)] dark:shadow-none">
      <button
        type="button"
        data-date-preset-trigger
        class="flex h-8 shrink-0 items-center gap-2 rounded-md border-0 bg-transparent px-1 text-[13px] font-semibold text-[#26415C] transition-colors hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart"
        [attr.aria-expanded]="datePresetMenuOpen"
        aria-label="Open date range presets"
        (click)="toggleDatePresetMenu($event)"
      >
        <i class="pi pi-filter text-[13px] text-[#26415C] dark:text-muted"></i>
        <span>Filters</span>
        <i class="pi pi-chevron-down text-[9px] text-[#66758A] transition-transform dark:text-muted" [class.rotate-180]="datePresetMenuOpen"></i>
      </button>

      <div class="flex select-none items-center gap-1.5 text-[11px] font-medium text-[#66758A] dark:text-muted">
        <span class="hidden sm:inline">Start Date</span>
        <p-datepicker #startDatePicker
          class="w-[148px] shrink-0"
          [style]="{ width: '148px' }"
          [ngModel]="startDate"
          (ngModelChange)="onDateSelect('start', $event)"
          [maxDate]="endDate ?? undefined"
          dateFormat="dd/mm/yy"
          placeholder="DD/MM/YYYY"
          [showIcon]="true"
          [showButtonBar]="true"
          [readonlyInput]="true"
          [keepInvalid]="true"
          iconDisplay="input"
          icon="pi pi-calendar"
          appendTo="body"
          inputStyleClass="h-7 w-[148px] rounded-md border border-[#D7E0EA] bg-white py-0 pl-2 pr-7 text-[12px] text-[#10192D] outline-none focus:border-[#129E91] dark:border-topbar-line dark:bg-chart dark:text-ink cursor-pointer"
          ariaLabel="Start Date"
        />
      </div>

      <div class="flex select-none items-center gap-1.5 text-[11px] font-medium text-[#66758A] dark:text-muted">
        <span class="hidden sm:inline">End Date</span>
        <p-datepicker #endDatePicker
          class="w-[148px] shrink-0"
          [style]="{ width: '148px' }"
          [ngModel]="endDate"
          (ngModelChange)="onDateSelect('end', $event)"
          [minDate]="startDate ?? undefined"
          dateFormat="dd/mm/yy"
          placeholder="DD/MM/YYYY"
          [showIcon]="true"
          [showButtonBar]="true"
          [readonlyInput]="true"
          [keepInvalid]="true"
          iconDisplay="input"
          icon="pi pi-calendar"
          appendTo="body"
          inputStyleClass="h-7 w-[148px] rounded-md border border-[#D7E0EA] bg-white py-0 pl-2 pr-7 text-[12px] text-[#10192D] outline-none focus:border-[#129E91] dark:border-topbar-line dark:bg-chart dark:text-ink cursor-pointer"
          ariaLabel="End Date"
        />
      </div>

      @if (startDate || endDate) {
        <button
          type="button"
          (click)="onDateChange()"
          [disabled]="!startDate || !endDate"
          class="flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-[#129E91]/35 bg-[#129E91]/10 p-0 text-[#129E91] transition-colors hover:bg-[#129E91] hover:text-white disabled:cursor-not-allowed disabled:opacity-40 dark:border-primary/40 dark:bg-primary/10 dark:text-primary dark:hover:bg-primary dark:hover:text-white"
          aria-label="Apply date range"
          title="Apply date range"
        >
          <i class="pi pi-search text-[11px]"></i>
        </button>
        <button
          type="button"
          (click)="clearDateRange()"
          class="flex h-7 w-7 shrink-0 items-center justify-center rounded-md border-0 bg-transparent p-0 text-[#8A96A8] transition-colors hover:bg-[#F0F4F8] hover:text-[#10192D] dark:text-muted dark:hover:bg-chart dark:hover:text-ink"
          aria-label="Clear date range"
          title="Clear date range"
        >
          <i class="pi pi-times text-[11px]"></i>
        </button>
      }

      @if (isOverviewRoute) {
        <div class="ml-auto flex shrink-0 items-center gap-2">
        <span class="mx-1 h-5 w-px shrink-0 bg-[#D7E0EA] dark:bg-topbar-line"></span>
        <button
          type="button"
          data-date-preset-trigger
          class="inline-flex h-7 shrink-0 items-center gap-1.5 rounded-md border-0 bg-transparent px-1.5 text-[11px] font-bold text-[#26415C] hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart"
          [attr.aria-expanded]="comparisonDatePresetMenuOpen"
          aria-label="Open comparison date range presets"
          (click)="toggleComparisonDatePresetMenu($event)"
        >
          <span>Compare with</span>
          <i class="pi pi-chevron-down text-[8px] text-[#66758A] transition-transform dark:text-muted" [class.rotate-180]="comparisonDatePresetMenuOpen"></i>
        </button>
        <div class="flex select-none items-center gap-1 text-[11px] font-medium text-[#66758A] dark:text-muted">
          <span class="hidden 2xl:inline">Start</span>
          <p-datepicker #comparisonStartDatePicker
            class="w-[148px] shrink-0"
            [style]="{ width: '148px' }"
            [ngModel]="comparisonStartDate"
            (ngModelChange)="onComparisonDateSelect('start', $event)"
            [maxDate]="comparisonEndDate ?? undefined"
            dateFormat="dd/mm/yy"
            placeholder="DD/MM/YYYY"
            [showIcon]="true"
            [showButtonBar]="true"
            [readonlyInput]="true"
            [keepInvalid]="true"
            iconDisplay="input"
            icon="pi pi-calendar"
            appendTo="body"
            inputStyleClass="h-7 w-[148px] rounded-md border border-[#D7E0EA] bg-white py-0 pl-2 pr-7 text-[12px] text-[#10192D] outline-none focus:border-[#129E91] dark:border-topbar-line dark:bg-chart dark:text-ink cursor-pointer"
            ariaLabel="Comparison Start Date"
          />
        </div>
        <div class="flex select-none items-center gap-1 text-[11px] font-medium text-[#66758A] dark:text-muted">
          <span class="hidden 2xl:inline">End</span>
          <p-datepicker #comparisonEndDatePicker
            class="w-[148px] shrink-0"
            [style]="{ width: '148px' }"
            [ngModel]="comparisonEndDate"
            (ngModelChange)="onComparisonDateSelect('end', $event)"
            [minDate]="comparisonStartDate ?? undefined"
            dateFormat="dd/mm/yy"
            placeholder="DD/MM/YYYY"
            [showIcon]="true"
            [showButtonBar]="true"
            [readonlyInput]="true"
            [keepInvalid]="true"
            iconDisplay="input"
            icon="pi pi-calendar"
            appendTo="body"
            inputStyleClass="h-7 w-[148px] rounded-md border border-[#D7E0EA] bg-white py-0 pl-2 pr-7 text-[12px] text-[#10192D] outline-none focus:border-[#129E91] dark:border-topbar-line dark:bg-chart dark:text-ink cursor-pointer"
            ariaLabel="Comparison End Date"
          />
        </div>
        <button type="button" (click)="applyComparisonDateRange()" [disabled]="!startDate || !endDate || startDate > endDate || !comparisonStartDate || !comparisonEndDate || comparisonStartDate > comparisonEndDate" class="flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-violet-500/40 bg-violet-500/10 text-violet-500 transition-colors hover:bg-violet-500 hover:text-white disabled:cursor-not-allowed disabled:opacity-40" aria-label="Run comparison for selected date range" title="Run comparison"><i class="pi pi-chart-bar text-[11px]"></i></button>
        @if (comparisonStartDate || comparisonEndDate) {
          <button type="button" (click)="clearComparisonDateRange()" class="flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-[#8A96A8] hover:bg-[#F0F4F8] dark:hover:bg-chart" aria-label="Clear comparison date range" title="Clear comparison date range"><i class="pi pi-times text-[11px]"></i></button>
        }
        </div>
      }
    </div>

    @if (datePresetMenuOpen) {
      <div
        data-date-preset-menu
        class="absolute left-0 top-[44px] z-[90] w-[350px] max-w-[calc(100vw-24px)] overflow-hidden rounded-lg border border-[#D7E0EA] bg-white text-[12px] text-[#10192D] shadow-2xl dark:border-topbar-line dark:bg-[#0F1826] dark:text-ink"
        (click)="$event.stopPropagation()"
      >
        <div class="bg-[#F4F6F8] px-3 py-2 font-semibold dark:bg-chart">Date range presets</div>

        <div class="divide-y divide-[#E8EDF2] dark:divide-line">
          <div class="py-1">
            <button type="button" class="flex w-full items-center justify-between border-0 bg-transparent px-3 py-2 text-left hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart" (click)="applyDatePreset('thisMonth')">
              <span>This month</span>
            </button>
            <button type="button" class="flex w-full items-center justify-between border-0 bg-transparent px-3 py-2 text-left hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart" (click)="applyDatePreset('thisFinancialYear')">
              <span>This financial year</span>
            </button>
          </div>

          <div class="py-1">
            <button type="button" class="flex w-full items-center justify-between border-0 bg-transparent px-3 py-2 text-left hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart" (click)="applyDatePreset('lastMonth')">
              <span>Last month</span>
            </button>
            <button type="button" class="flex w-full items-center justify-between border-0 bg-transparent px-3 py-2 text-left hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart" (click)="applyDatePreset('lastQuarter')">
              <span>Last quarter</span>
            </button>
            <button type="button" class="flex w-full items-center justify-between border-0 bg-transparent px-3 py-2 text-left hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart" (click)="applyDatePreset('lastFinancialYear')">
              <span>Last financial year</span>
            </button>
          </div>

          <div class="py-1">
            <button type="button" class="flex w-full items-center justify-between border-0 bg-transparent px-3 py-2 text-left hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart" (click)="applyDatePreset('monthToDate')">
              <span>Month to date</span>
            </button>
            <button type="button" class="flex w-full items-center justify-between border-0 bg-transparent px-3 py-2 text-left hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart" (click)="applyDatePreset('quarterToDate')">
              <span>Quarter to date</span>
            </button>
            <button type="button" class="flex w-full items-center justify-between border-0 bg-transparent px-3 py-2 text-left hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart" (click)="applyDatePreset('yearToDate')">
              <span>Year to date</span>
            </button>
          </div>

          <button type="button" class="flex w-full items-center gap-2 border-0 bg-transparent px-3 py-3 text-left hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart" (click)="datePresetMenuOpen = false">
            <i class="pi pi-calendar text-[11px]"></i>
            <span>Custom date range</span>
            <span class="ml-auto text-[#66758A] dark:text-muted">Select above</span>
          </button>
        </div>
      </div>
    }

    @if (comparisonDatePresetMenuOpen) {
      <div
        data-date-preset-menu
        class="absolute right-0 top-[44px] z-[90] w-[350px] max-w-[calc(100vw-24px)] overflow-hidden rounded-lg border border-[#D7E0EA] bg-white text-[12px] text-[#10192D] shadow-2xl dark:border-topbar-line dark:bg-[#0F1826] dark:text-ink"
        (click)="$event.stopPropagation()"
      >
        <div class="bg-[#F4F6F8] px-3 py-2 font-semibold dark:bg-chart">Comparison date presets</div>

        <div class="divide-y divide-[#E8EDF2] dark:divide-line">
          <div class="py-1">
            <button type="button" class="flex w-full border-0 bg-transparent px-3 py-2 text-left hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart" (click)="applyDatePreset('thisMonth', 'comparison')">This month</button>
            <button type="button" class="flex w-full border-0 bg-transparent px-3 py-2 text-left hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart" (click)="applyDatePreset('thisFinancialYear', 'comparison')">This financial year</button>
          </div>

          <div class="py-1">
            <button type="button" class="flex w-full border-0 bg-transparent px-3 py-2 text-left hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart" (click)="applyDatePreset('lastMonth', 'comparison')">Last month</button>
            <button type="button" class="flex w-full border-0 bg-transparent px-3 py-2 text-left hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart" (click)="applyDatePreset('lastQuarter', 'comparison')">Last quarter</button>
            <button type="button" class="flex w-full border-0 bg-transparent px-3 py-2 text-left hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart" (click)="applyDatePreset('lastFinancialYear', 'comparison')">Last financial year</button>
          </div>

          <div class="py-1">
            <button type="button" class="flex w-full border-0 bg-transparent px-3 py-2 text-left hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart" (click)="applyDatePreset('monthToDate', 'comparison')">Month to date</button>
            <button type="button" class="flex w-full border-0 bg-transparent px-3 py-2 text-left hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart" (click)="applyDatePreset('quarterToDate', 'comparison')">Quarter to date</button>
            <button type="button" class="flex w-full border-0 bg-transparent px-3 py-2 text-left hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart" (click)="applyDatePreset('yearToDate', 'comparison')">Year to date</button>
          </div>

          <button type="button" class="flex w-full items-center gap-2 border-0 bg-transparent px-3 py-3 text-left hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart" (click)="comparisonDatePresetMenuOpen = false">
            <i class="pi pi-calendar text-[11px]"></i>
            <span>Custom date range</span>
            <span class="ml-auto text-[#66758A] dark:text-muted">Select above</span>
          </button>
        </div>
      </div>
    }
    </div>
    }
  </div>

  <!-- Right side: Controls -->
  <div class="topbar-actions flex items-center flex-shrink-0 gap-1 sm:gap-2 lg:gap-5">

    @if (showDashboardControls) {
    <!-- Export button hidden temporarily.
    <button
      type="button"
      (click)="exportClick.emit()"
      class="flex items-center justify-center sm:justify-start w-8 h-8 sm:w-auto sm:h-auto sm:gap-1.5 rounded-md sm:rounded-none text-[12px] font-medium text-[#8A96A8] dark:text-muted hover:text-[#10192D] dark:hover:text-ink hover:bg-[#F0F4F8] dark:hover:bg-chart sm:hover:bg-transparent transition-colors cursor-pointer bg-transparent border-0 p-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#129E91] dark:focus-visible:outline-primary"
      aria-label="Export dashboard"
      title="Export"
    >
      <i class="pi pi-download text-[12px]"></i>
      <span class="hidden sm:inline">Export</span>
    </button>
    -->
    }

    <!-- Sync Now -->
    @if (isBalanceSheetItemsRoute) {
      <button
        type="button"
        id="topbar-sync-btn"
        (click)="balanceSheetItemsState.requestSync()"
        [disabled]="balanceSheetItemsState.syncRunning()"
        class="inline-flex items-center gap-1.5 rounded-lg bg-primary px-3 py-1.5 text-[12px] font-semibold text-white shadow-sm transition-all duration-150 hover:opacity-90 active:scale-95 disabled:cursor-not-allowed disabled:opacity-60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
        title="Sync Now"
      >
        <i class="pi text-[11px]" [class.pi-sync]="!balanceSheetItemsState.syncRunning()" [class.pi-spinner]="balanceSheetItemsState.syncRunning()" [class.pi-spin]="balanceSheetItemsState.syncRunning()"></i>
        <span class="hidden sm:inline">{{ balanceSheetItemsState.syncRunning() ? 'Syncing…' : 'Sync Now' }}</span>
      </button>
    }

    <!-- Divider -->
    <div class="hidden lg:block w-px h-3.5 bg-[#E8EDF2] dark:bg-line"></div>

    <!-- Dark / Light mode toggle -->
    <button
      type="button"
      (click)="theme.toggle()"
      class="flex items-center justify-center w-8 h-8 sm:w-7 sm:h-7 rounded-full sm:rounded-full text-[#8A96A8] dark:bg-white/[0.06] dark:text-[#B4C0D1] hover:text-[#10192D] dark:hover:text-white hover:bg-[#F0F4F8] dark:hover:bg-white/[0.12] transition-colors cursor-pointer bg-transparent border-0 p-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#129E91] dark:focus-visible:outline-primary"
      [title]="(theme.isDark$ | async) ? 'Light mode' : 'Dark mode'"
    >
      @if (theme.isDark$ | async) {
        <i class="pi pi-sun text-[13px]"></i>
      } @else {
        <i class="pi pi-moon text-[13px]"></i>
      }
    </button>

    <!-- User menu -->
    <div class="relative">
      <button
        type="button"
        (click)="toggleUserMenu($event)"
        class="flex items-center gap-1.5 rounded-full border-0 bg-transparent p-0 cursor-pointer transition-transform hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
        [attr.aria-expanded]="userMenuOpen"
        aria-label="Account menu"
        title="Account"
      >
        <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-tr from-primary via-info to-primary p-[2px] shadow-sm dark:from-primary/70 dark:via-info/50 dark:to-primary/70 dark:shadow-none">
          <span class="flex h-full w-full items-center justify-center overflow-hidden rounded-full border-2 border-white bg-white dark:border-topbar-line dark:bg-topbar">
            <app-avatar [name]="userName" size="md"></app-avatar>
          </span>
        </span>
        <i class="pi pi-angle-down hidden text-[9px] text-[#8A96A8] transition-transform dark:text-[#B4C0D1] sm:block" [class.rotate-180]="userMenuOpen"></i>
      </button>

      @if (userMenuOpen) {
        <div
          class="absolute right-0 top-[40px] z-[90] w-56 max-w-[calc(100vw-24px)] overflow-hidden rounded-lg border border-[#D7E0EA] bg-white text-[12px] text-[#10192D] shadow-2xl dark:border-topbar-line dark:bg-[#0F1826] dark:text-ink"
          (click)="$event.stopPropagation()"
        >
          <div class="border-b border-[#E8EDF2] px-3.5 py-3 dark:border-topbar-line">
            <p class="font-semibold truncate">{{ userName || 'User' }}</p>
            @if (userRole) {
              <p class="text-[11px] text-[#66758A] dark:text-muted truncate">{{ userRole }}</p>
            }
          </div>
          <a
            routerLink="/profile"
            (click)="userMenuOpen = false"
            class="flex items-center gap-2 px-3.5 py-2.5 text-[#10192D] no-underline hover:bg-[#F0F4F8] dark:text-ink dark:hover:bg-chart"
          >
            <i class="pi pi-user text-[11px]"></i>
            <span>Profile</span>
          </a>
        </div>
      }
    </div>

  </div>

</header>
